import script from "./BoundleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BoundleDetail.vue?vue&type=script&setup=true&lang=js"

import "./BoundleDetail.vue?vue&type=style&index=0&id=2a2ab8d4&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2ab8d4"]])

export default __exports__